import React, { useEffect, useState } from 'react';
import { signOut } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link, useNavigate } from 'react-router-dom';
import auth from '../../firebase.init';
import DeleteManageOrder from './DeleteManageOrder';

const ManageAllOrders = () => {

    const [user] = useAuthState(auth)
    const [myOrders, setMyOrder] = useState([]);
    const [reload, setIsReload] = useState(true)
    const [deleteProduct, setDeleteProduct] = useState(null)
    const navigate = useNavigate()

    console.log(deleteProduct)

    useEffect(() => {

        async function fetchMyAPI() {
            const url = `https://young-everglades-39818.herokuapp.com/allorders`;
            try {
                await fetch(url, {
                    headers: {
                        authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                })
                    .then(res => res.json())
                    .then(data => setMyOrder(data))
            }
            catch (error) {
                console.log(error.message);
                if (error.response.status === 401 || error.response.status === 403) {
                    signOut(auth);
                    localStorage.removeItem('accessToken');
                    navigate('/');
                }
            }
        }
        fetchMyAPI()
    }, [reload])




    const handleItemShiped = id => {

        const url = `https://young-everglades-39818.herokuapp.com/myorders/${id}`;
        fetch(url, {
            method: 'PUT'
        })
            .then(res => res.json())
            .then(data => {
                setIsReload(!reload)
            })

    }

    return (
        <div class="overflow-x-auto">
            <table class="table w-full">
                <thead>
                    <tr>
                        <th></th>
                        <th>Product Name</th>
                        <th>Quantity</th>
                        <th>Amount</th>
                        <th>Action Status</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        myOrders.map((myOrder, index) => <tr>
                            <th>{index + 1}</th>
                            <td>{myOrder.productN}</td>
                            <td>{myOrder.purchaseQ}</td>
                            <td>${myOrder.totalPrice}</td>
                            <td>
                                {(!myOrder.ship && !myOrder.paid) && <button className='btn btn-xs btn-blue-400 mx-2'>unPaid</button>}

                                {(!myOrder.ship && myOrder.paid) && <button className='btn btn-xs btn-blue-400 mx-2'>Paid</button>}

                                {(!myOrder.ship && !myOrder.paid) && <label for="my-modal-2" class="btn btn-xs btn-primary mx-2" onClick={() => setDeleteProduct(myOrder)}>Delete</label>}



                                {(myOrder.paid && !myOrder.ship) && <button className='btn btn-xs btn-primary mx-2' onClick={() => handleItemShiped(myOrder._id)}>Pending</button>}

                                {(myOrder.paid && myOrder.ship) && <button className='btn btn-xs btn-blue-400 mx-2'>Shipped</button>}


                            </td>
                            {deleteProduct && <DeleteManageOrder deleteProduct={deleteProduct} reload={reload} setIsReload={setIsReload}></DeleteManageOrder>}
                        </tr>)
                    }


                </tbody>
            </table>
        </div >
    );
};

export default ManageAllOrders;